const animate = require('client/animate');
const playlist = document.querySelector('.playlist');
const player = document.querySelector('.screencast-player');
const playlistContainer = document.querySelector('.screencast-player__nav');
const main = document.querySelector('.screencast-player__main');
const topNotification =
	document.querySelector('.notification.notification_top') || null;
const TOP_NOTIFICATION_HEIGHT = topNotification
  ? topNotification.offsetHeight
  : 0;
const footer = document.querySelector('.page-footer');
const FOOTER_HEIGHT = 72;
let animation;
let animationDirection = '';
let lastScrollPosition = 0;
let bottomReached = false;
let animationFinished = true;

// player.style.height = `calc(100vh - 60px - ${TOP_NOTIFICATION_HEIGHT}px`;

module.exports = function onScroll() {
  if (
    (lastScrollPosition < main.scrollTop && animationDirection === 'down') ||
		(lastScrollPosition > main.scrollTop && animationDirection === 'up')
  ) {
    cancelAnimationFrame(animation);
  } else if (!animationFinished) {
    return;
  }

  lastScrollPosition = main.scrollTop;
  const startPosition = parseInt(getComputedStyle(footer).bottom);
  const initialMainScroll = main.scrollTop;
  const initialPlaylistScroll = playlistContainer.scrollTop;

  if (main.offsetHeight + main.scrollTop >= main.scrollHeight) {
    if (bottomReached) return;
    const distanceToGo = -startPosition;
    if (distanceToGo === 0) return;
    animationFinished = false;

    animate({
      timing: fraction => {
        // what distance footer has already covered
        return distanceToGo * fraction;
      },
      // how fast footer has to go up to cover remaining distance with defined scroll speed
      duration: (distanceToGo / FOOTER_HEIGHT) * 200,
      draw: progress => {
        footer.style.bottom = startPosition + progress + 'px';
        player.style.height = `calc(100vh - 60px - ${TOP_NOTIFICATION_HEIGHT}px - ${progress}px`;
        main.scrollTop = initialMainScroll + progress;
        playlistContainer.scrollTop = initialPlaylistScroll + progress;
      },
      callback: () => {
        bottomReached = true;
        animationFinished = true;
      }
    });
  } else {
    if (!bottomReached) return;
    const distanceToGo = FOOTER_HEIGHT + startPosition;
    if (distanceToGo === 0) return;
    animationFinished = false;

    animate({
      timing: fraction => {
        // what distance footer has already covered
        return distanceToGo * fraction;
      },
      // how fast footer has to go up to cover remaining distance
      duration: (distanceToGo / FOOTER_HEIGHT) * 200,
      draw: progress => {
        footer.style.bottom = startPosition - progress + 'px';
        player.style.height = `calc(100vh - 60px - ${TOP_NOTIFICATION_HEIGHT}px - ${FOOTER_HEIGHT -
					progress}px`;
        main.scrollTop = initialMainScroll - progress;
        playlistContainer.scrollTop = initialPlaylistScroll - progress;
      },
      callback: () => {
        bottomReached = false;
        animationFinished = true;
      }
    });
  }
};
